import styled from "styled-components";

export const ImageLogo = styled.img`
  width: 550px;
  height: 300px;
  padding: 20px 20px;
  @media (max-width: 551px) {
    width: 100%;
    height: auto;
    padding: 0px;
  }

  @media (max-width: 426px) {
    display: none;
  }
`;

export const ImageLogoMobile = styled.img`
  display: none;

  @media (max-width: 426px) {
    display: block;
    width: 45%;
    height: auto;
    padding-top: 10px;
  }
`;

export const Message = styled.div`
  width: 550px;
  padding: 0px 20px;
`;
